import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined'
import { C } from './tokens'

/** In place of a chart when the range holds no orders — never one giant bar. */
export default function Empty({ onTry30, message = 'No orders in this range.', compact = false }) {
  return (
    <Box sx={{ height: '100%', minHeight: compact ? 120 : 200, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', gap: 1, border: `1px dashed ${C.border}`, borderRadius: '8px', bgcolor: '#FBFBFC' }}>
      <InsightsOutlinedIcon sx={{ fontSize: compact ? 24 : 32, color: C.textFaint }} aria-hidden />
      <Typography sx={{ fontSize: 14, color: C.text, fontWeight: 500 }}>{message}</Typography>
      {onTry30 ? (
        <Button size="small" onClick={onTry30} sx={{ textTransform: 'none', color: C.brandText, fontWeight: 600 }}>
          Try 30 days
        </Button>
      ) : null}
    </Box>
  )
}
